<div
  class="kanban-wrapper"
  [class.minimized]="summaryMinimized"
  [class.has-many-columns]="hasManyColumns">
  @if (loading) {
    <!-- Skeleton Loading quando não há cache -->
    <app-kanban-skeleton
      [columnCount]="skeletonColumnCount"
      [cardCountPerColumn]="skeletonCardCount">
    </app-kanban-skeleton
    >w
  } @else {
    @if (columns; as columnList) {
      <div class="kanban" [class.many-columns]="hasManyColumns" [class.fill-width]="isFillingWidth">
        @for (column of columnList; track column.id; let columnIndex = $index) {
          <div
            class="kanban-column"
            [attr.data-column-id]="column.id"
            [class.column-drag-over]="column.id === highlightedColumnId"
            [class.column-receiving]="isColumnReceiving(column.id)"
            [class.minimized]="isColumnMinimized(column.id)">
            <header class="kanban-header">
              <div class="header-content">
                @if (columnHeaderPrefixTemplate) {
                  <ng-container
                    *ngTemplateOutlet="
                      columnHeaderPrefixTemplate;
                      context: { $implicit: column }
                    " />
                }
                <span class="stage-name">{{ column.name }}</span>
                @if (!isColumnLoading(column.id)) {
                  <span class="stage-count">{{ countOf(column) }}</span>
                }
              </div>
              <div class="header-actions">
                @if (isColumnLoading(column.id)) {
                  <i
                    class="pi pi-spin pi-spinner loading-indicator"
                    style="margin-left: 8px; color: #007bff"></i>
                }
                <button
                  class="minimize-button"
                  (click)="onMinimizeClick(column.id, $event)"
                  [class.minimized]="isColumnMinimized(column.id)">
                  <i
                    class="pi"
                    [class.pi-chevron-left]="!isColumnMinimized(column.id)"
                    [class.pi-chevron-right]="isColumnMinimized(column.id)"></i>
                </button>
              </div>
            </header>
            <div class="vertical-title" *ngIf="isColumnMinimized(column.id)">
              @if (!isColumnLoading(column.id)) {
                <span class="minimized-count">{{ countOf(column) }}</span>
              }
              <span class="minimized-name">{{ column.name }}</span>
            </div>

            <!--
              Invariante: o ngx-drag-drop calcula o índice do drop pela posição do placeholder
              entre os FILHOS DIRETOS deste elemento. Não acrescente nem remova elemento aqui
              sem refazer a conta de ordem de quem usa o board.
            -->
            <div
              class="kanban-body"
              dndDropzone
              dndEffectAllowed="copyMove"
              [dndDisableIf]="dragDisabled"
              (dndDrop)="onDrop($event, column)"
              (dndDragover)="columnDragOver.emit(column.id)"
              (dndDragleave)="columnDragLeave.emit(column.id)">
              <div
                class="placeholder-item dndPlaceholder"
                [class.active-drop-zone]="isActiveDragZone(column.id) && !dragDisabled"
                dndPlaceholderRef>
                <div class="placeholder-content">
                  @if (dragDisabled) {
                    {{ dragDisabledMessage }}
                  } @else {
                    {{ isActiveDragZone(column.id) ? 'Soltar aqui!' : 'Soltar aqui' }}
                  }
                </div>
              </div>
              @if (isColumnEmpty(column)) {
                <div
                  class="empty-column-dropzone"
                  style="position: absolute; top: 0; left: 0; right: 0; bottom: 0">
                  <!-- Dentro da dropzone, e não ao lado: um filho a mais no .kanban-body mudaria
                       o índice do drop (ver o invariante acima). -->
                  @if (emptyColumnMessageOf(column); as mensagem) {
                    <p class="kanban-column-empty-message">{{ mensagem }}</p>
                  }
                </div>
              }

              <!-- Itens ativos -->
              @for (item of activeItemsOf(column); track item.id) {
                <div
                  class="card-wrapper"
                  [class.card-entering]="isItemEntering(item.id)"
                  [class.card-leaving]="isItemLeaving(item.id)">
                  <div
                    class="draggable-item"
                    [dndDraggable]="item"
                    [dndEffectAllowed]="'copyMove'"
                    [dndDisableIf]="dragDisabled || isItemDragDisabled(item)"
                    dndDraggableClass="draggable-card dnd-drag-dragging"
                    dndDraggingSourceClass="dndDraggingSource"
                    (dndStart)="onDragStart(item, column.id)"
                    (dndEnd)="itemDragEnd.emit()">
                    @if (cardTemplate) {
                      <ng-container
                        *ngTemplateOutlet="
                          cardTemplate;
                          context: { $implicit: item, column: column, completed: false }
                        " />
                    }
                  </div>
                </div>
              }

              <!-- Seção de concluídos -->
              @if (completedItemsOf(column).length > 0) {
                <div class="completed-deals-section">
                  <div class="completed-deals-header" (click)="completedToggle.emit(column.id)">
                    <div class="completed-deals-title">
                      <i
                        class="pi"
                        [class.pi-chevron-down]="!isCompletedCollapsed(column.id)"
                        [class.pi-chevron-right]="isCompletedCollapsed(column.id)">
                      </i>
                      <span>{{ completedLabel }} ({{ completedItemsOf(column).length }})</span>
                    </div>
                  </div>

                  <div
                    class="completed-deals-content"
                    [class.collapsed]="isCompletedCollapsed(column.id)">
                    @for (item of completedItemsOf(column); track item.id) {
                      <div
                        class="card-wrapper completed-deal"
                        [class.card-entering]="isItemEntering(item.id)"
                        [class.card-leaving]="isItemLeaving(item.id)">
                        <div
                          class="draggable-item"
                          [dndDraggable]="item"
                          [dndEffectAllowed]="'copyMove'"
                          [dndDisableIf]="dragDisabled || isItemDragDisabled(item)"
                          dndDraggableClass="draggable-card dnd-drag-dragging"
                          dndDraggingSourceClass="dndDraggingSource"
                          (dndStart)="onDragStart(item, column.id)"
                          (dndEnd)="itemDragEnd.emit()">
                          <div class="completed-deal-card-wrapper">
                            @if (cardTemplate) {
                              <ng-container
                                *ngTemplateOutlet="
                                  cardTemplate;
                                  context: { $implicit: item, column: column, completed: true }
                                " />
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }

              <!-- Dropzone vazia que ocupa o resto da coluna -->
              <div
                class="empty-column-dropzone"
                style="background: transparent; border: none; min-height: 100px"
                [class.column-drag-over]="highlightedColumnId === column.id"></div>
            </div>
          </div>
        } @empty {
          <div class="empty">
            <h1 class="subTitle text-center">
              {{ emptyMessage }}
            </h1>
          </div>
        }
      </div>
      <!-- Linha de resumo no bottom -->
      <div
        class="kanban-summary-bottom"
        [class.minimized]="summaryMinimized"
        [class.many-columns]="hasManyColumns"
        [class.fill-width]="isFillingWidth">
        <div class="summary-toggle" (click)="summaryToggle.emit()">
          <i
            class="pi"
            [class.pi-chevron-down]="!summaryMinimized"
            [class.pi-chevron-up]="summaryMinimized"></i>
        </div>
        <div class="summary-content">
          @for (column of columnList; track column.id) {
            <div
              class="summary-column"
              [style.flex]="
                isColumnMinimized(column.id)
                  ? '0 0 50px'
                  : isFillingWidth
                    ? '1 0 235px'
                    : '0 0 235px'
              "
              [style.max-width.px]="
                isColumnMinimized(column.id) ? 50 : isFillingWidth ? null : 235
              ">
              @if (!isColumnMinimized(column.id)) {
                <div class="summary-info">
                  <div class="summary-totals">
                    @for (total of totalsOf(column); track total.currency) {
                      <div class="currency-total">
                        <div class="currency-info">
                          <span class="currency">{{ total.currency }}:</span>
                          <span class="count">({{ total.count }})</span>
                        </div>
                        <span class="value">{{ total.value | vaultFormatCurrency: 2 }}</span>
                      </div>
                    }
                  </div>
                </div>
              } @else {
                <span class="summary-minimized-count">{{ countOf(column) }}</span>
              }
            </div>
          }
        </div>
      </div>
    }
  }
</div>
